import React from 'react';
import { Box } from '@mantine/core';
import { GRAY } from '../constants';
import styles from './ColumnBlock.module.scss';

/** A titled white tile in the comparison matrix — the attribute label repeated per column. */
export const ColumnBlock: React.FC<{ title: React.ReactNode; children: React.ReactNode }> = ({ title, children }) => (
  <Box className={styles.block}>
    <Box fw={600} lh={1.2} c={GRAY} className={styles.title}>
      {title}
    </Box>
    {children}
  </Box>
);
